
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 141.7 141.7","overflow":"visible"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FC0","d":"M0 5.3v59.9h65.4V5.3L65.3 0H.2zM0 81.6v59.9h65.4V81.6l-.1-5.3H.2zM76.3 81.6v59.9h65.4V81.6l-.1-5.3h-65zM76.3 5.3v59.9h65.3l.1-59.9-.1-5.3H76.9z"}}),_c('path',{attrs:{"fill":"#836682","d":"M85.1 56.7H133V8.6H85.1zM8.7 133h48V84.9h-48z"}}),_c('path',{attrs:{"fill":"#66962E","d":"M85.3 114.9l-.4 18.1h48.3l-.2-20.8c-3.8 1.3-9.3 5.2-13.5 3.7-2.4-.8-3.9-3.2-6.4-3.6-3.4-.5-3.2 1.1-7.3 2.1l-3-4.3c1.2-2.2-.2-.2 1.3-1.8 2.4-2.5 4.2-2.7 4.9-6.2 1.1-5.4-1-9.2-4.7-10.3-5.1-1.6-9.2.4-11.1 3.3-3.5 5.2-1 7.4.8 11.5l-8.7 8.3zM9 38.6l-.4 18.2h48.3L56.7 36c-3.8 1.3-9.3 5.2-13.5 3.7-2.4-.8-4-3.1-6.4-3.5-3.4-.5-3.2 1.1-7.3 2.1l-3-4.3c2.1-3.9 5.3-3.5 6.2-8.1 2.5-12.4-11.6-13.5-15.9-7-3.4 5.2-1 7.4.8 11.6L9 38.6z"}}),_c('path',{attrs:{"fill":"#66D6F2","d":"M9 38.6l8.6-8.3c-1.8-4.2-4.2-6.3-.8-11.6 4.3-6.5 18.4-5.4 15.9 7-.9 4.6-4.1 4.1-6.2 8.1l3 4.3c4.1-1 3.9-2.6 7.3-2.1 2.5.4 4 2.7 6.4 3.5 4.2 1.4 9.7-2.4 13.5-3.7V8.5h-48L9 38.6zM85.3 114.9l8.6-8.3c-1.8-4.2-4.2-6.3-.8-11.5 1.9-3 6-4.9 11.1-3.3 3.7 1.1 5.8 4.9 4.7 10.3-.7 3.5-2.5 3.7-4.9 6.2-1.6 1.6-.1-.4-1.3 1.8l3 4.3c4.1-1 3.9-2.6 7.3-2.1 2.5.4 4 2.7 6.4 3.6 4.2 1.4 9.7-2.5 13.5-3.7V84.9H85.1l.2 30z"}}),_c('path',{attrs:{"fill":"#FC0","d":"M14.2 101.3h13.1v26.1h10.9v-26.1h13.1v-11H14.2zM90.5 24.9h13.1v26.2h10.9V24.9h13.1V14H90.5z"}})])])
          )
        }
      }
    